import { render, staticRenderFns } from "./AddSimpleFilter.vue?vue&type=template&id=4f7a6770"
import script from "./AddSimpleFilter.vue?vue&type=script&lang=js"
export * from "./AddSimpleFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports